import React, { Component } from 'react'
import { Nav, PushContent } from './../../../components'
import { GiftStyle } from './../../../styles'
import Router from './../../../services/Router'
import { withLoader } from '../../../hoc/withLoader'

class Gift extends Component {
  state = {
    nav : [
      // {
      //   value: 'Gift',
      //   url: Router.gifts.path
      // },
      {
        value: 'Quizzes',
        url: Router.hubQuizz.path
      },
      {
        value: 'Ranking',
        url: Router.ranking.exactPath
      },
    ],
    gifts: [],
  }

  returnSup = (sup) => {
    let str = 'th'
    switch (sup) {
      case 0:
        str = 'st'
        break;
      case 1:
        str = 'nd'
        break;
      case 3:
        str = 'rd'
        break;
    
      default:
        break;
    }

    return str
  }

  render() {
    const { data, isReady } = this.props
    const { nav } = this.state
    return(
      <div className={`gift page-inner ${GiftStyle}`}>
        <Nav nav={nav} />
        <div className={`gift-container flex transition ${isReady ? 'transition--ready' : ''}`}>
          {
            data && data.map((gift, index) => (
              <div className={`gift ${index < 3 ? 'highlight' : ''}`} key={index}>
                <div className="gift-inner">
                  <span className="gift-number">
                    {index + 1}
                    <sup>{this.returnSup(index)}</sup>
                  </span>
                  <PushContent {...gift} />
                </div>
              </div>
            ))
          }
        </div>
      </div>
    )
  }
}

export default withLoader(Gift, '/challenge/quiz/gifts')


// WEBPACK FOOTER //
// ./src/scenes/Pages/container/Gift.js